import React from "react"
import { Router } from "react-router-dom"
import history from './history'
import { CssBaseline } from '@mui/material'
import { SWRConfig } from 'swr'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { dayInMs } from './utils/constants'
import { GeneralProvider } from './context/general'
import { PaletteThemeProvider, usePaletteTheme } from './context/paletteTheme'
import MainApp from './MainApp'
import { jwtDecode } from "jwt-decode";
import axios from "axios"

const swrJsonFetch = async (resource, init) => {
  // console.log("resource :- ",resource);
  // console.log("init :- ",init);
  
  const res = await axios.get(resource)
  if (!res.status === 200) {
    const error = new Error('An error occurred.')
    error.info = await res.data
    error.status = res.status
    throw error
  }
  return res.data
}



function Platform() {
  const { theme } = usePaletteTheme()


  function checkAndRemoveExpiredItems() {
    const token = localStorage.getItem("fe_token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const exp = decoded?.exp;

      if (!exp) return;

      const currentTime = Date.now() / 1000;
      if (currentTime >= exp) {
        localStorage.removeItem("fe_token");
        history.push("/login");
      }
    } catch (e) {
      // corrupted token
      localStorage.removeItem("fe_token");
      history.push("/login");
    }
  }

    
  setInterval(checkAndRemoveExpiredItems, 5000);

  return (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SWRConfig value={{fetcher: swrJsonFetch, revalidateOnFocus: false, dedupingInterval: dayInMs}}>
            <Router history={history}>
              <GeneralProvider>
                <MainApp />
              </GeneralProvider>
            </Router>
          </SWRConfig>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default function App() {
  return (
    <React.StrictMode>
      <PaletteThemeProvider>
        <Platform/>
      </PaletteThemeProvider>
    </React.StrictMode>
  )
}